/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interior_SpaceInputs */

const en_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interior Space`)
};

const es_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio interior`)
};

const fr_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espace intérieur`)
};

const de_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innenfläche`)
};

const ja_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`室内面積`)
};

const zh_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`室内面积`)
};

const ar_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المساحة الداخلية`)
};

const id_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Interior`)
};

const it_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazio Interno`)
};

const ru_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутренняя площадь`)
};

const pt_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço Interno`)
};

const ko_interior_space = /** @type {(inputs: Interior_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실내 면적`)
};

/**
* | output |
* | --- |
* | "Interior Space" |
*
* @param {Interior_SpaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const interior_space = /** @type {((inputs?: Interior_SpaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interior_SpaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_interior_space(inputs)
	if (locale === "es") return es_interior_space(inputs)
	if (locale === "fr") return fr_interior_space(inputs)
	if (locale === "de") return de_interior_space(inputs)
	if (locale === "ja") return ja_interior_space(inputs)
	if (locale === "zh") return zh_interior_space(inputs)
	if (locale === "ar") return ar_interior_space(inputs)
	if (locale === "id") return id_interior_space(inputs)
	if (locale === "it") return it_interior_space(inputs)
	if (locale === "ru") return ru_interior_space(inputs)
	if (locale === "pt") return pt_interior_space(inputs)
	return ko_interior_space(inputs)
});